import { useEffect, useRef, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Snowfall from "@/components/Snowfall";
import SleighRide from "@/components/SleighRide";
import NavBar from "@/components/NavBar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ChartSection from "@/components/ChartSection";
import CommunitySection from "@/components/CommunitySection";
import Footer from "@/components/Footer";
import { playJingle } from "@/lib/jingle";

function App() {
  const [snowOn, setSnowOn] = useState(true);
  const [chimeOn, setChimeOn] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (!chimeOn) return undefined;
    if (!audioRef.current) {
      audioRef.current = new (window.AudioContext || window.webkitAudioContext)();
    }
    const ctx = audioRef.current;
    ctx.resume();
    playJingle(ctx);
    const id = setInterval(() => playJingle(ctx), 24000);
    return () => clearInterval(id);
  }, [chimeOn]);

  return (
    <div className="min-h-screen overflow-x-hidden bg-[#070A0F] text-slate-100 selection:bg-[#FF2B4A]/60">
      <Snowfall active={snowOn} />
      <SleighRide />
      <NavBar
        snowOn={snowOn}
        onToggleSnow={() => setSnowOn((s) => !s)}
        chimeOn={chimeOn}
        onToggleChime={() => setChimeOn((c) => !c)}
      />
      <main>
        <Hero />
        <Marquee />
        <ChartSection />
        <CommunitySection />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
